// removed by extract-text-webpack-plugin
module.exports = {"page-wrapper":"page-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/MainContent/Index.scss
// module id = 1375
// module chunks = 0